Drupal.behaviors.share_widget = {
  attach() {
    const shareButton = document.querySelector('.share-link');

    if (shareButton) {
      const {title} = window.document;
      const url = window.document.location.href;

      shareButton.addEventListener('click', () => {
        if (navigator.share) {
          navigator
            .share({
              title: `${title}`,
              url: `${url}`,
            })
            .then(() => {
            })
            .catch(console.error);
        }
        else {
          var dummy = document.createElement('input'),
            text = window.location.href;
          document.body.appendChild(dummy);
          dummy.value = text;
          dummy.select();
          document.execCommand('copy');
          document.body.removeChild(dummy);
          document.querySelector('.share-link .tooltip').style.transition = 'opacity 2s';
          document.querySelector('.share-link .tooltip').style.opacity = '100%';
          setTimeout(() => {
            document.querySelector('.share-link .tooltip').style.opacity = '0%';
          }, 2000);

        }
      });
    }
  }
}


